<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview
        ref="RealTimeNeTree"
        :fields="fields"
        :nodeSelected="nodeSelectedOfNeTreeForTask"
      ></ejs-treeview>
    </div>
  </div>
</template>

<script>
import * as dataSource from "./a.json";

class TreeDatas {
  constructor(dataSource) {
    this.dataSource = !!dataSource ? dataSource : [{ children: [] }];
    this.id = 'id';
    this.text = 'text';
    this.child = 'children';
    this.expanded = 'state';
  }
}

export default {
  name: 'RealTimeNeTree',
  data() {
    return {
      fields: new TreeDatas()
    };
  },
  mounted() {
    this.getNeInfoUnderTaskTree();
  },
  methods: {
    // 加载网元树数据
    getNeInfoUnderTaskTree() {
      const _this = this;
      this.$axios
        .get('/lte/pm/tree/currenttime/neInfoUnderTaskTree.html?systemId=1')
        .then(response => {
          _this.fields = new TreeDatas(response.data);
        });
    },
    // 处理树的单击事件
    nodeSelectedOfNeTreeForTask(args) {
      let neId = '';
      let neTypeId = '';
      let attributes = this.$refs.RealTimeNeTree.getTreeData(
        args.nodeData.id
      )[0].attributes;
      if (attributes) {
        neId = attributes.neId ? attributes.neId : '';
        neTypeId = attributes.neTypeId ? attributes.neTypeId : '';
      }
      const params = {
        neId: neId,
        neTypeId: neTypeId,
        treeType: '2'
      };
      this.$emit('transferNe', params);
    }
  }
};
</script>

<style>
</style>
